<template>
  <svg enable-background="new 0 0 24 24" height="512" viewBox="0 0 24 24" width="512" xmlns="http://www.w3.org/2000/svg">
    <path d="m23 12c0 .75-.42 1.41-1.03 1.75l-5.2 2.89-4.4-4.64 4.4-4.64 5.2 2.89c.61.34 1.03 1 1.03 1.75z" fill="#f7c945" />
    <path d="m12.37 12-10.8 11.39c-.36-.36-.57-.85-.57-1.39v-20c0-.54.21-1.03.57-1.39z" fill="#5bcffa" />
    <path d="m12.37 12 4.4 4.64c-13.173 7.225-13.725 8.307-15.2 6.75z" fill="#f44336" />
    <path d="m16.77 7.36-4.4 4.64-10.8-11.39c.618-.653 1.609-.796 2.4-.36z" fill="#6dea81" />
  </svg>
</template>
<script>
export default {
  name: 'GooglePlay',
};
</script>
